const SITE = 'https://goislandride.com';
const BIZ_ID = `${SITE}/#business`;

export function breadcrumb(name, path) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    '@id': `${SITE}${path}/#breadcrumb`,
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Home', item: SITE + '/' },
      { '@type': 'ListItem', position: 2, name, item: `${SITE}${path}/` },
    ],
  };
}

export function webPage(name, description, path) {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${SITE}${path}/#webpage`,
    url: `${SITE}${path}/`,
    name,
    description,
    isPartOf: { '@id': `${SITE}/#website` },
  };
}

export function service(name, serviceType, description, path, offers) {
  const s = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    '@id': `${SITE}${path}/#service`,
    name,
    serviceType,
    description,
    provider: { '@id': BIZ_ID },
    areaServed: { '@type': 'Place', name: 'Staten Island' },
    url: `${SITE}${path}/`,
  };
  if (offers) s.offers = offers;
  return s;
}

export function contactPage() {
  return {
    '@context': 'https://schema.org',
    '@type': 'ContactPage',
    '@id': `${SITE}/contact/#contactpage`,
    url: `${SITE}/contact/`,
    name: 'Contact Island Ride',
    description: 'Contact Island Ride by phone, WhatsApp, or email for Staten Island local rides, airport trips, and out-of-town travel.',
    isPartOf: { '@id': `${SITE}/#website` },
    about: { '@id': BIZ_ID },
  };
}
